import React, { useEffect, useId, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export const getDailyExceptionText = (reason, repeated) => {
  if (!repeated) return "";
  if (reason === "male_presence") return "Più incarichi nella stessa giornata: l’autocompilazione ha riutilizzato questa persona per garantire almeno un uomo nel turno.";
  if (reason === "couple_integrity") return "Più incarichi nella stessa giornata: l’autocompilazione ha riutilizzato questa persona per mantenere i coniugi nello stesso turno.";
  return "Questa persona è assegnata a più turni nella stessa giornata. Il motivo dell’eccezione non è stato registrato: verifica gli incarichi.";
};

export default function TurnVolunteerName({ name, warning = "", tooltip = "", className = "" }) {
  const anchor = useRef(null);
  const tooltipId = useId();
  const [position, setPosition] = useState(null);
  useEffect(() => {
    const hide = () => setPosition(null);
    window.addEventListener("scroll", hide, true);
    window.addEventListener("resize", hide);
    return () => { window.removeEventListener("scroll", hide, true); window.removeEventListener("resize", hide); };
  }, []);
  const show = () => {
    const rect = anchor.current.getBoundingClientRect();
    const width = Math.min(320, window.innerWidth - 24);
    setPosition({ width, left: Math.max(12, Math.min(rect.left, window.innerWidth - width - 12)),
      ...(rect.top > 160 ? { bottom: window.innerHeight - rect.top + 8 } : { top: rect.bottom + 8 }) });
  };
  return <>
    <button ref={anchor} type="button"
      className={`inline-flex items-center gap-1 min-w-0 max-w-full min-h-[28px] text-left font-medium rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${warning ? "bg-orange-100 text-orange-900 ring-1 ring-orange-300 px-1.5" : className}`}
      aria-label={warning ? `${name}. ${warning}` : name}
      aria-describedby={position ? tooltipId : undefined}
      onMouseEnter={show} onMouseLeave={() => setPosition(null)}
      onFocus={show} onBlur={() => setPosition(null)}
      onKeyDown={e => { if (e.key === "Escape") setPosition(null); }}
      onClick={show}>
      {warning && <ExclamationTriangleIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}
      <span className="truncate">{name}</span>
    </button>
    {position && createPortal(<div id={tooltipId} role="tooltip"
      className="fixed z-[100] rounded-xl border border-slate-700 bg-slate-900 px-3 py-2.5 text-xs leading-relaxed text-white shadow-xl pointer-events-none"
      style={position}>
      {warning && <div className="mb-1 font-semibold text-orange-300">Eccezione giornaliera</div>}
      {warning || tooltip || name}
    </div>, document.body)}
  </>;
}
